import React from "react"
import axios from "axios"; // TODO - Components which are used by admin as well need to import axios at the moment
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

import { theme, styles } from "@root/Components/Inputs/SelectInput";
import API from "../../../Common/API";

const UserGroupSelector = (props) => {
    const { multi, onChange, selected } = props;

    const [ value, setValue ] = React.useState(selected);

    const handleChange = (vals, meta) => {
        let newValue = (vals === null ? [] : vals);
        setValue(newValue);
        onChange('groups', newValue);
    }

    const promiseOptions = inputValue =>
        new Promise(resolve => {
            let url = API.getUrl(props.module, `components/select/usergroups/${props.actionContext}`);
            axios.get(url, {
                params: {
                    search: inputValue
                }
            })
                .then(res => {
                    resolve(res.data.results);
                });
        });

    return (
        <AsyncSelect
            className="react-select-container"
            isMulti={multi}
            defaultOptions={true}
            placeholder=""
            loadOptions={promiseOptions}
            onChange={handleChange}
            value={value}
            styles={styles}
            theme={theme}
        />
    )
}

UserGroupSelector.propTypes = {
    module: PropTypes.string.isRequired,
    multi: PropTypes.bool,
    selected: PropTypes.array,
    actionContext: PropTypes.string,
}

UserGroupSelector.defaultProps = {
    multi: false,
    selected: [],
    actionContext: 'add',
}

export default UserGroupSelector;
